<template>
  <div class="home-category-view">
    <!-- 影片類型列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="video-info"
        v-for="item in list"
        :key="item.videoID"
        @click="toVideoDetail(item)"
      >
        <div>
          <van-image class="video-img" :src="item.photo" lazy-load />
        </div>

        <div class="video-label">
          &ensp;{{ item.videoName }}．{{ item.actorName }}．{{ item.onDate }}
        </div>

        <!-- <hr class="video-hr" /> -->
        <van-divider
          :style="{
            borderColor: 'black',
            margin: '0.3125rem 0.3125rem 0.0625rem 0.3125rem',
          }"
        ></van-divider>
      </div>
    </van-list>
  </div>
</template>

<script>
// HomeCategoryView : 影片類型列表-浮動選單
// call by HomeView.vue,

import { List, Cell, CellGroup, Image, Divider } from "vant";

export default {
  name: "homeCategoryView",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Divider.name]: Divider,
  },
  props: {
    params: {},
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,

      categoryID: 0,
    };
  },
  computed: {},
  created() {
    var manuVal = this.params;
    this.categoryID = parseInt(manuVal.split("=")[1]);
  }, //created
  methods: {
    onLoad() {
      if (this.finished) {
        return;
      }

      this.loading = true;

      var category = this.categoryID;

      this.page++;
      var secret = process.env.VUE_APP_SECRET;
      var base_url = process.env.VUE_APP_BASE_URL;
      var timeKey = this.$timeKey();
      var postKey = this.$md5(
        category.toString() + this.page.toString() + timeKey + secret
      );

      var url = base_url + "/CategoryVideoPlus";

      var that = this;
      this.$ajax
        .get(url, {
          params: {
            Category: category,
            Page: that.page,
            PostKey: postKey,
          },
        })
        .then(function (response) {
          let res = response.data.data;

          if (res.length > 0) {
            //把 data 加入 list
            res.forEach((item) => {
              that.list.push(item);
            });
            //小於 30 筆,沒有下一頁
            if (res.length < 10) {
              that.finished = true;
            }
          } else {
            that.finished = true;
          }

          // 加载状态结束
          that.loading = false;
        })
        .catch(function (err) {
          // 出錯
          console.log(err);
          that.loading = false;
        });
    }, //onLoad

    /*     toVideoDetail(item) {
      this.$router.push({
        name: "videodetail",
        query: {
          videoID: item.videoID,
          videoName: item.videoName
        }
      });
    }, //toVideoDetail */

    toVideoDetail(item) {
      this.$router.push({
        name: "videodetailx",
        query: {
          videoDetail: JSON.stringify(item),
        },
      });
    }, //toVideoDetail

    initData() {
      return true;
    },
  }, //methods
};
</script>

<style>
.home-category-view {
  font-family: "Arial", "Helvetica", "sans-serif";
}

.home-category-view .video-img {
  width: 100%;
  padding: 0.3125rem 0 0.3125rem 0;
}
.home-category-view .video-label {
  /* padding: 0 0.3125rem 0 0.3125rem; */
  font-family: "Arial", "Helvetica", "sans-serif";
}
.home-category-view .video-hr {
  margin: 0.3125rem 0.3125rem 0.0625rem 0.3125rem;
}
</style>
